import React from "react";
import {TableViewBtn } from '../../../images/Svgs'
import { CustomToolTip } from "../../../utils/common";

const TransactionsList = ({transactionList,onTransactionDetail }) => { 
    return (
        <div className="">
            <div className="row">
                <div className="col-12">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Email Address</th>
                                <th scope="col">Transaction ID</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Payment Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transactionList && transactionList?.length > 0 && transactionList?.map((item,i) => {
                                return (
                                    <tr key={item.id}>
                                        <td className="text-capitalize">{item?.user?.first_name || '-'} {item?.user?.last_name}</td>
                                        <td>{item?.payer_email_address}</td>
                                        <td>{item?.transaction_id}</td>
                                        <td >${item?.amount}</td>
                                        <td >{item?.payment_status}</td>
                                        <td>
                                            <button type="button" className="btn position-relative" onClick={() => onTransactionDetail(item)}><TableViewBtn /> <CustomToolTip type='view' title='Transaction' /></button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default TransactionsList;
